import React from "react";
import {Drawer, List, Toolbar} from "@mui/material";
import MenuContent from "./MenuContent";

const drawerWidth = 240;

const Sidebar: React.FC = () => {
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar/>
      <List>
        <MenuContent/>
      </List>
    </Drawer>
  );
};

export default Sidebar;
